import type { RoutingState } from './types';

const initialState: RoutingState = {
  currentPath: '/',
  hash: undefined,
  navigateDuration: undefined,
  navigateStart: undefined,
  navigate: undefined,
  params: {},
  path: '/',
  pathname: '/',
  prevPath: undefined,
  routeState: undefined,
  search: undefined,
};

export default initialState;
